import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { DonorService } from "../../Services/Donor.Service";

function DonateSample({ userData, samples, getSampleCost, fetchSamples, selectedLab ,setToastMessage, setToastVariant, setShowToast, setLoading, handleDonateYes, fetchProfile }) {
 
    const handleSampleOption = (setFieldValue, id, value) => {
      if((selectedLab === "" || selectedLab === null ) && value === "1"){
        handleDonateYes();
      }
      setFieldValue(id, value);
      if(id === 'is_donor' && value === "1") {
          fetchSamples(selectedLab);
      }
    };

  const validationSchema = Yup.object().shape({
    is_donor: Yup.string().required("Please select your willingness to donate samples"),
    sample_types: Yup.object().when("is_donor", {
      is: "1", // only validate if Yes
      then: (schema) =>
        schema
          .test(
            "at-least-one-checked",
            "Please select at least one sample type",
            (value) => value && Object.values(value).some((isChecked) => isChecked)
          )
          .required("Sample type selection is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    blood_volume: Yup.number()
      .nullable()
      .when("sample_types.1", {
        is: true,
        then: (schema) =>
          schema
            .min(1, "Blood volume should not be less than 1 mL")
            .max(150, "Blood volume cannot exceed 150 mL")
            .required("Blood volume is required when Blood sample is selected"),
        otherwise: (schema) => schema.notRequired(),
      }),
  });
// console.log("oooi", userData.is_donor_status?.toString());
// transform API response to form shape

const getInitialValues = (userData) => {
  // When no lab selected yet, or lab just changed => reset form
  if (!selectedLab && userData.is_donor_status?.toString() === "1") {
    return {
      is_donor: "",
      sample_types: {},
      blood_volume: "",
    };
  }

  const sample_types = {};
  let blood_volume = "";

  if (userData?.samples?.length > 0) {
    userData.samples.forEach((sample) => {
      sample_types[sample.sample_id] = true; // mark as checked
      if (sample.sample_id === 1 && sample.volume) {
        blood_volume = sample.volume; // prefill blood volume
      }
    });
  }

  return {
    is_donor: userData?.is_donor_status?.toString() || "",
    sample_types,
    blood_volume,
  };
};

  // transformer util
  const transformToDonateSamples = (samples, blood_volume) => {
    const donateSamples = {};
    if (samples !== undefined) {
      Object.keys(samples).forEach((sampleId) => {
        const sampleStatus = samples[sampleId];
        if (sampleStatus === true) {
          donateSamples[sampleId] = {
            willing_to_donate: 1,
            volume: sampleId === "1" ? blood_volume : null,
          };
        }
      });
    }
    return donateSamples;
  };


  const handleSubmit = async (values) => {
    setLoading(true);
    try {
       if (!selectedLab && values.is_donor === "1") {
        setToastMessage("Please select a Lab before saving donation samples.");
        setToastVariant("danger");
        setShowToast(true);
        setLoading(false);

        // scroll to lab field (assuming it has an id="lab-section")
        const labElement = document.getElementById("lab-section");
        if (labElement) {
          labElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return; // stop submit
      }
      const params = {
        user_id : userData.id,
        donate_sample: values.is_donor === "1" ? 1 : 0,
      };
      if(params.donate_sample){
        params.donate_samples = transformToDonateSamples(
          values.sample_types,
          values.blood_volume
        );
      }

      
      const result  = await DonorService.updateDonateSample(params);
      if(result.success){
        await fetchProfile("update");   
        setLoading(false);
        setToastMessage("Donate samples updated successfully.");
        setToastVariant("success");
        setShowToast(true); 
      }
    } catch (error) {
      setLoading(false);
      console.error("Failed to update donate samples:", error);
      setToastMessage(error.message);
      setToastVariant("danger");
      setShowToast(true);
    }
  };

  // Generate resetKey only if lab is selected and donor is "Yes"
const resetKey =
  selectedLab && userData?.is_donor_status === "1"
    ? `${selectedLab}-donor`
    : "static";

  return (
    <div className="el-bg-table el-super-admin mt-3">
      <Formik
        key={resetKey}
        initialValues={getInitialValues(userData)} 
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}  //  to update initialValues when props change
        // validateOnChange={false}   //  disable auto-validation
        // validateOnBlur={false}     //  disable auto-validation
      >
        {({ values, setFieldValue, errors, touched, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Accordion className="el-custom-accordion" alwaysOpen defaultActiveKey={["donate-sample"]} flush>
            <Accordion.Item eventKey="donate-sample" id="donate-sample-section">
              <Accordion.Header className="cursor-pointer">
                <b>Donate Samples</b>
              </Accordion.Header>
              <Accordion.Body>
                <container className="el-property-details-card-content">
                  <Row>
                    <Col md={12} className="mx-fit-content">
                        {/* Yes / No Question */}
                        {/* <label className="form-label">Will you donate samples? <span className="text-red">*</span></label> */}
                       <div className="d-flex justify-content-between mt-3  ">
                    <div className="w-75">
                         <p className="donate-st-question">Do you want to be actively matched with opportunities to donate samples and get paid? <br></br> <span className="mt-2">You can change it at any time.</span></p>
                          </div>  <div className="w-25 d-flex g-3 donate-el-between-radio-button">
                            {["1", "0"].map((is_donor) => (
                                <div className="form-check" key={is_donor}>
                                <Field
                                    type="radio"
                                    name="is_donor"
                                    value={is_donor}
                                    className="form-check-input"
                                    onChange={() => handleSampleOption(setFieldValue, "is_donor", is_donor.toString())} //1 is for donor
                                />
                                <label className="form-check-label">
                                    &nbsp; {is_donor === "1" ? "Yes" : "No"}
                                </label>
                                </div>
                            ))}
                        </div></div>
                        <ErrorMessage name="is_donor" component="div" className="text-danger" />
                      {/* Only show sample list if Yes */}
                      {values.is_donor === "1" && samples?.length > 0 && (
                        <div className="row mt-3 col-xl-12">
                          <div className="col-md-12">
                            <h6> <b>
                              Select sample types you are willing to donate.</b>
                            </h6>
                            <p className="donate-st-question">
                              You’ll be required to sign paperwork for each sample
                              type you are willing to donate. Keep an eye on your
                              email for details.
                            </p>
                          </div>

                          <div className="col-md-12 mt-3">
                            {samples.map((option) => (
                              <div key={option.sample_id} className="mb-3">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`checkbox-${option.sample_id}`}
                                    checked={!!values.sample_types[option.sample_id]}
                                    onChange={() =>{
                                      setFieldValue(
                                        `sample_types.${option.sample_id}`,
                                        !values.sample_types[option.sample_id]
                                      )
                                      }
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`checkbox-${option.sample_id}`}
                                  >
                                    {option.sample_name}{" "}
                                    {getSampleCost(option.sample_id)
                                      ? ` - ${
                                          getSampleCost(option.sample_id, values)
                                            .cost
                                        }`
                                      : ""}
                                  </label>
                                </div>

                                {/* Blood volume input if blood sample is selected */}
                                {option.sample_id === 1 &&
                                  values.sample_types[1] && (
                                    <>
                                      <div className="row">
                                        <div className="col-xl-2 mt-2  ">
                                          <Field
                                            type="number"
                                            name="blood_volume"
                                            className="form-control"
                                            placeholder="Max ML per donation"
                                            onKeyDown={(e) => {
                                              if (e.key === "-" || e.key === "+") {
                                                e.preventDefault();
                                              }
                                            }}
                                          />
                                        </div>
                                        <div className="col-xl-2 mt-2 mb-1 align-content-center">
                                          <small>(5ml increments)</small>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name="blood_volume"
                                        component="div"
                                        className="text-danger"
                                      />
                                      <p >
                                        maximum willing to donate (mL), up to 150
                                        per day
                                      </p>
                                    </>
                                  )}
                              </div>
                            ))}
                          </div>
                            <ErrorMessage name="is_donor" component="div" className="text-danger" />
                            {errors.sample_types && (
                                <div className="text-danger">{errors.sample_types}</div>
                            )}
                        </div>
                      )}
                    </Col>
                  </Row>
                </container>
              </Accordion.Body>
            </Accordion.Item>
            </Accordion>
            <div className="d-flex align-items-center mt-3">
              <button type="submit" className="el-main-button me-3">
                <span>Save Changes</span>
              </button>
            </div>
           {/* {JSON.stringify(errors)} */}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default DonateSample;
